import * as React from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import { StringDateRange, ValType } from '../move_me/StringDateRange';
import { VFFieldProps } from '../types';
import { FormItem } from './FormItem';

type Props = {
  onChange?: (val: ValType) => void;
  onBlur?: (val: ValType) => void;
} & VFFieldProps<React.ComponentProps<typeof StringDateRange>>;

export const DateRange: React.FC<Props> = ({
  name,
  validate,
  //label,
  onChange: $onChange,
  onBlur: $onBlur,
  className,
  label,
  disabled,
  required,
  ...other
}) => {
  return (
    <FormItem
      name={name}
      className={className}
      label={label}
      required={required}
      disabled={disabled}
    >
      <Field name={name} validate={validate}>
        {({ input: { value, onChange } }: FieldRenderProps<ValType>) => (
          <StringDateRange
            value={value}
            onChange={(value) => {
              onChange({ target: { name, value: value } });
              $onChange && $onChange(value);
            }}
            onBlur={(value) => {
              $onBlur && $onBlur(value);
            }}
            {...other}
            disabled={disabled}
          />
        )}
      </Field>
    </FormItem>
  );
};
